<template>
  <EmptyList
    v-if="!portfolioSymbols.length && !watchList.length"
    :title="t('modules.watchlist.noWatchlistTitle')"
    :body="t('modules.watchlist.noWatchlistMessage')"
    title-class="text-center mt-3"
    class="h-auto m-auto p-2 flex flex-col justify-center items-center bg-neutral-primary rounded-md"
  >
    <template #image>
      <Image src="empty_box" alt="not_found" class="w-28 h-max" />
    </template>

    <div class="flex flex-col items-center justify-center">
      <NButton
        v-gid="{
          module: 'watchlist',
          screen: 'home',
          section: 'watchlistTable',
          component: 'createWatchlistButton',
        }"
        variant="flat"
        color="green"
        class="px-6 mt-3"
        @click="
          () =>
            openCreateWatchlistDialog({
              handleAfterCreateWatchlist: () =>
                emit('handleAfterCreateWatchlist'),
            })
        "
      >
        <NText weight="bold" variant="caption1">
          {{ t('modules.watchlist.create') }}
        </NText>
      </NButton>
    </div>
  </EmptyList>

  <EmptyList
    v-else-if="isPortfolioSelected"
    :title="t('modules.portfolio.emptyPortfolioTitle')"
    :body="t('modules.portfolio.emptyPortfolioMessage')"
    title-class="text-center mt-3"
    class="h-auto m-auto p-2 flex flex-col justify-center items-center bg-neutral-primary rounded-md"
  >
    <template #image>
      <Image src="empty_box" alt="not_found" class="w-28 h-max" />
    </template>

    <div class="flex flex-col items-center justify-center">
      <NButton
        v-gid="{
          module: 'watchlist',
          screen: 'home',
          section: 'watchlistTable',
          component: 'brokerChangeButton',
        }"
        variant="flat"
        color="green"
        class="px-6"
        @click="openBrokerChangeDialog"
      >
        <NText weight="bold" variant="caption1">
          {{ t('symbol.broker_change') }}
        </NText>
      </NButton>

      <NButton
        v-gid="{
          module: 'watchlist',
          screen: 'home',
          section: 'watchlistTable',
          component: 'createWatchlistButton',
        }"
        variant="flat"
        color="green"
        class="px-6 mt-3"
        @click="
          () =>
            openCreateWatchlistDialog({
              handleAfterCreateWatchlist: () =>
                emit('handleAfterCreateWatchlist'),
            })
        "
      >
        <NText weight="bold" variant="caption1">
          {{ t('modules.watchlist.create') }}
        </NText>
      </NButton>
    </div>
  </EmptyList>

  <EmptyList
    v-else
    :title="t('modules.watchlist.emptyWatchlistTitle')"
    :body="t('modules.watchlist.emptyWatchlistMessage')"
    title-class="text-center mt-3"
    class="h-auto m-auto p-2 flex flex-col justify-center items-center bg-neutral-primary rounded-md"
  >
    <template #image>
      <Image src="empty_box" alt="not_found" class="w-28 h-max" />
    </template>
  </EmptyList>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { PortfolioItem, Watchlist } from '@libs/api-reference';

import { useSymbolDialogs } from '@/modules/symbol';
import { useWatchlistDialogs } from '@/modules/watchlist';

import EmptyList from '@/components/EmptyList.vue';
import Image from '@/components/Image.vue';

const emit = defineEmits<{
  (e: 'handleAfterCreateWatchlist'): Promise<void>;
}>();
defineProps<{
  isPortfolioSelected: boolean;
  portfolioSymbols: PortfolioItem[];
  watchList: Watchlist[];
}>();

const { t } = useI18n();

const { openBrokerChangeDialog } = useSymbolDialogs();
const { openCreateWatchlistDialog } = useWatchlistDialogs();
</script>
